module.exports = __webpack_public_path__ + "static/media/logo.56be6ca5.svg";